export const GET_ROLES_REQUEST = "GET_ROLES_REQUEST"
export const GET_ROLES_SUCCESS = "GET_ROLES_SUCCESS"
export const GET_ROLES_FAILURE = "GET_ROLES_FAILURE"
export const GET_NEXT_PAGE_ROLES_REQUEST = "GET_NEXT_PAGE_ROLES_REQUEST"

export const GET_PERMISSIONS_REQUEST = "GET_PERMISSIONS_REQUEST"
export const GET_PERMISSIONS_SUCCESS = "GET_PERMISSIONS_SUCCESS"
export const GET_PERMISSIONS_FAILURE = "GET_PERMISSIONS_FAILURE"
